import { render, staticRenderFns } from "./BannerPC.vue?vue&type=template&id=65c9e26e&scoped=true"
import script from "./BannerPC.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerPC.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BannerPC.vue?vue&type=style&index=0&id=65c9e26e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c9e26e",
  null
  
)

export default component.exports